import { Checkbox } from 'antd';
import { useEffect, useState } from 'react';

const CheckListInput = props => {
    const { def, data, onChange, state } = props;
    const inline = def.variant === 'inline'
    const [previousValue, setPreviousValue] = useState(undefined);

    useEffect(() => {
        setPreviousValue(data);
    }, [data]);

    const onCheckListChange = (checkedValues) => {
        if (!state.readonly) {
            onChange(def.dataKey, checkedValues, null, previousValue);
            setPreviousValue(checkedValues);
        }
    }

    return <Checkbox.Group
        inline={inline}
        onChange={onCheckListChange}
        value={data}
        data-input={'checklistinput_de'}
        className={'checklistinput_de'}
    >
        {def.values.map((val, idx) => {
            const label = def.options[idx];
            return <>
                <Checkbox
                    key={`${def.dataKey}_${val}_${idx}`}
                    value={val}
                >
                    {label}
                </Checkbox>
                {!inline && <br />}
            </>;
        })}
    </Checkbox.Group>
}

export default CheckListInput;
